import { createTheme } from "@mui/material";

export const DefaultTheme = createTheme({
	
	palette: {
		secondary: {
			main: '#799145',
			// light: will be calculated from palette.primary.main,
			// dark: will be calculated from palette.primary.main,
			// contrastText: will be calculated to contrast with palette.primary.main
		},
		primary: {
			main: '#434D76',
			// light: will be calculated from palette.secondary.main,
			// dark: will be calculated from palette.secondary.main,
			// contrastText: will be calculated to contrast with palette.primary.main
		},
		warning: {
			main: '#a87f25',
			light: '#b98a25',
		},
		error: {
			main: '#a82525',
			
		},
		info: {
			main: '#434D76',
		}
	},
	components: {
		MuiTextField: {
			defaultProps: {
				size: "small",
			}
		},
		MuiSelect: {
			defaultProps: {
				size: "small",
			}
		}
	}
});

